module.exports = __webpack_public_path__ + "static/feature-5-29c275d716a40f99b4a8f6b1731bef6e.svg";